import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { updateSelectedDropdownUser, updateRequest } from '../../../../stores/AssignDeviceStore';
import { RootState } from '../../../../stores/Store';

import AutoComplete from '../../../../components/AutoComplete/AutoComplete';
import Button from '../../../../components/Button/Button';
import ButtonGroup from '../../../../components/ButtonGroup/ButtonGroup';
import TextInput from '../../../../components/TextInput/TextInput';
import useAssignUserSelectUserStep from './useAssignUserSelectUserStep';
import { User } from '../../../../models/UsersModels';

interface AssignUserSelectUserStepProps {
  nextStep: () => void;
  onClose: () => void;
}
function AssignUserSelectUserStep({ nextStep, onClose }: AssignUserSelectUserStepProps) {
  const [t] = useTranslation();
  const selectedDropdownUser = useSelector((state: RootState) => state.assignDeviceReducer.selectedDropdownUser);
  const [query, setQuery] = useState(selectedDropdownUser.label);
  const { userOptions, isLoading } = useAssignUserSelectUserStep(query as string);
  const dispatch = useDispatch();

  /**
   * Renders user details when a user is selected
   */
  const renderUserDetails = () => {
    if (selectedDropdownUser.data) {
      const user = selectedDropdownUser.data as User;
      return (
        <>
          <TextInput
            id="email"
            name="email"
            onInputChange={() => {}}
            value={user.email}
            placeholder={t('pages.devicesReport.assignUserDrawer.email')}
            label={t('pages.devicesReport.assignUserDrawer.email')}
            disabled
            formStyle={{ paddingBottom: '1.5rem' }}
          />
          <TextInput
            id="firstName"
            name="firstName"
            onInputChange={() => {}}
            value={user.firstName}
            placeholder={t('pages.devicesReport.assignUserDrawer.firstName')}
            label={t('pages.devicesReport.assignUserDrawer.firstName')}
            disabled
            formStyle={{ paddingBottom: '1.5rem' }}
          />
          <TextInput
            id="lastName"
            name="lastName"
            onInputChange={() => {}}
            value={user.lastName}
            placeholder={t('pages.devicesReport.assignUserDrawer.lastName')}
            label={t('pages.devicesReport.assignUserDrawer.lastName')}
            disabled
            formStyle={{ paddingBottom: '1.5rem' }}
          />
        </>
      );
    }

    return null;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ paddingBottom: '2rem' }}>
        <Box sx={{ paddingBottom: '1.5rem' }}>
          <AutoComplete
            onInputChange={(val) => setQuery(val as string)}
            value={selectedDropdownUser}
            label={t('pages.devicesReport.assignUserDrawer.selectUser')}
            placeholder={t('pages.devicesReport.assignUserDrawer.selectUserPlaceholder')}
            onChange={(opt) => {
              if (opt) {
                dispatch(updateRequest({ userId: opt.value as string }));
                dispatch(updateSelectedDropdownUser(opt));
              }
            }}
            isLoading={isLoading}
            options={userOptions}
            disablePortal={false}
          />
        </Box>
        {renderUserDetails()}
      </Box>
      <Box sx={{ marginTop: 'auto' }}>
        <ButtonGroup>
          <Button label={t('common.cancel')} color="alternative2Button" onClick={onClose} />
          <Button
            label={t('common.continue')}
            color="primaryButton"
            disabled={!selectedDropdownUser.key}
            onClick={nextStep}
          />
        </ButtonGroup>
      </Box>
    </Box>
  );
}

export default AssignUserSelectUserStep;
